export default __webpack_public_path__ + "12d36f2fe731baafb997d3775dc202f7.svg";